import { useMemo } from 'react';
import { Button, CloseLineIcon, Flex, Form, Text } from 'ui';
import { ChatInput, type ChatInputFormValues } from '../chat-input';
import type { UserToChat } from '../types';
import { ChatCreateUserSelect, useChatCreateUserSelectCreateOption } from './chat-create-user-select';
import type { ChatCreateUserOption } from './chat-create-user-select';
import { useCreateChat } from './hooks';

export type ChatCreateFormValues = {
  members?: ChatCreateUserOption[];
} & ChatInputFormValues;

type P = {
  onChatroomCreated?: (chatroomId: string) => void;
  onClose: () => Promise<void>;
  onCreated: (chatroomId: string) => Promise<void>;
  userToChat?: UserToChat;
};

const ChatCreate = ({ onChatroomCreated, onClose, onCreated, userToChat }: P) => {
  const { createChat } = useCreateChat({ onChatroomCreated, onCreated });
  const createOption = useChatCreateUserSelectCreateOption();
  const [form] = Form.useForm<ChatCreateFormValues>();
  const members = Form.useWatch('members', form);
  const initialMembers = useMemo(
    () => (userToChat ? [createOption(userToChat)] : undefined),
    [createOption, userToChat],
  );
  const initialValues: Partial<ChatCreateFormValues> = { attachments: [], members: initialMembers };

  return (
    <Form<ChatCreateFormValues> className="chat-create" form={form} initialValues={initialValues} onFinish={createChat}>
      <Flex className="chat-create__content" justify="space-between" vertical>
        <Flex align="center" gap="xxs">
          <Text>To:</Text>
          <Flex flex={1}>
            <Form.Item<ChatCreateFormValues> name="members" noStyle>
              <ChatCreateUserSelect defaultOpen={!userToChat} />
            </Form.Item>
          </Flex>
          <Button aria-label="Close" icon={<CloseLineIcon />} onClick={onClose} type="text" />
        </Flex>
        <ChatInput<ChatCreateFormValues> isVisible={Boolean(members?.length)} />
      </Flex>
    </Form>
  );
};

export default ChatCreate;
